<template>
  <!--<div id="indexBox">-->
    <!--<el-container class="wmCloudsWrapper">-->
      <!--<app-header></app-header>-->
    <!--<div id="layoutMainMail">-->
      <el-container class="wmCloudsContant">
        <!-- 邮箱左侧导航 -->
        <!--<app-aside></app-aside>-->
        <app-folder></app-folder>
        <!-- 设置左侧导航 -->
        <!--<asideSet style="display:none;"></asideSet>-->
        <!--<keep-alive exclude="layoutBoxMail">-->
        <!--<keep-alive include="layoutWriteMail">-->
        <keep-alive exclude="HomeBox">
        <!--<keep-alive>-->
        <router-view></router-view>
        </keep-alive>
        <!--<el-container>-->
          <!--<div class="flexbox wmCloudsMain">-->
            <!--<div class="wmCloudsBox">-->
              <!--&lt;!&ndash; 操作栏 &ndash;&gt;-->
              <!--<actionBar></actionBar>-->
              <!--&lt;!&ndash; 设置页面包屑导航 &ndash;&gt;-->
              <!--<setBreadNav style="display:none;"></setBreadNav>-->
              <!--&lt;!&ndash; 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS &ndash;&gt;-->
              <!--<div class="flexbox wmCloudsCount homeCloudsCount">-->
                <!--&lt;!&ndash; 邮件列表 &ndash;&gt;-->
                <!--<listBar></listBar>-->
                <!--&lt;!&ndash; view内容区 &ndash;&gt;-->
                <!--<div class="mainBar nice_scroll">-->
                  <!--<transition mode="out-in">-->
                    <!--<router-view></router-view>-->
                  <!--</transition>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash; 右侧页签 &ndash;&gt;-->
            <!--&lt;!&ndash;<tabBar></tabBar>&ndash;&gt;-->
          <!--</div>-->
          <!--&lt;!&ndash;<app-footer></app-footer>&ndash;&gt;-->
        <!--</el-container>-->
      </el-container>
    <!--</div>-->
    <!--</el-container>-->
  <!--</div>-->
</template>

<script>
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'
  import AppFolder from '@/components/sub/Folders.vue'
  import asideSet from '@/components/sub/asideSet.vue'
  import setBreadNav from '@/components/sub/setBreadNav.vue'
  import listBar from '@/components/sub/listBar.vue'
  import tabBar from '@/components/sub/tabBar.vue'
  import setComponent from "@/components/views/setBox/setComponent"
  import boxMail from "@/components/views/layout/boxMail"

  export default {
    name: 'layoutMainMail',
    data () {
      return {
      }
    },
    components:{
      setComponent,
      asideSet,
      setBreadNav,
      tabBar,
      listBar,
      'app-header': AppHeader,
      'app-footer': AppFooter,
      'app-folder': AppFolder,
      boxMail
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  }
</script>

<style scoped>
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/layout/MainHome.vue